import request from '@/utils/request'

// 获取登录验证码
export const getCaptcha = () =>
  request({
    url: '/captcha',
    method: 'get'
  })

// 登录
export const login = (data: any) =>
  request({
    url: 'manage/login',
    method: 'post',
    data
  })

// 获取菜单权限
export const getMenu = () =>
  request({
    url: 'manage/see-menu',
    method: 'get'
  })

// OSS Policy
export const getOssPlicy = () =>
  request({
    url: '/manage/oss-policy',
    method: 'post'
  })
